import React from "react";
import { View, TouchableWithoutFeedback, StyleSheet } from "react-native";
import Text from "@components/CustomText";
import AddToCart from "@assets/svg/AddToCart";
import { useSelector, useDispatch } from "react-redux";
import { actions as authActions } from "@reducers/authReducer";
import color from "@constants/color";
import { normalize } from "./metrics";

const KhareedBtn = ({
  width,
  onPress = () => {},
  disabled = false,
  testID = "",
}) => {
  const {
    user: { is_suspended = false, leader_state },
  } = useSelector(({ auth }) => auth);

  const dispatch = useDispatch();

  // CL suspension check
  // instead of checking suspenion for each add to cart call, we can just check here
  // and block the execution on props.onPress
  const isClSuspended = (event) => {
    if (is_suspended || leader_state === "LEADER_SUSPENDED") {
      dispatch(authActions.showSuspensionModal(true));
      return;
    }
    onPress(event);
  };

  return (
    <TouchableWithoutFeedback onPress={isClSuspended} testID={testID}>
      <View style={{ paddingBottom: 15 }}>
        <View style={[styles.container, { width: width || "auto" }]}>
          <View
            style={{
              flex: 1,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Text style={{ color: color.primary, fontSize: normalize(14) }}>
              खरीदें
            </Text>
          </View>
          <View style={styles.addCart}>
            <AddToCart />
          </View>
        </View>
      </View>
    </TouchableWithoutFeedback>
  );
};

export default KhareedBtn;

const styles = StyleSheet.create({
  container: {
    borderRadius: 6,
    borderWidth: 1,
    borderColor: color.primary,
    flexDirection: "row",
    alignItems: "stretch",
    height: normalize(30),
    overflow: "hidden",
    justifyContent: "space-between",
    marginRight: 1,
  },
  addCart: {
    width: normalize(30),
    backgroundColor: color.primary,
    alignItems: "center",
    justifyContent: "center",
    paddingTop: normalize(2),
  },
});
